const choices = {
    dynamic: 'Mon objectif est la rentabilité, je suis prêt à prendre des risques et subir des pertes',
    balanced: 'Je suis prêt à prendre un peu de risque pour gagner plus qu\'un livret ou fonds €',
    prudent: 'Je ne suis pas prêt à perdre de l\'argent par conséquent j\'accepte d\'avoir une faible rentabilité',
};

export default choices;
